import { createRoot } from 'react-dom/client'
import App from './App.tsx'
import './index.css'
import { cleanupStaleServiceWorkers } from './lib/serviceWorkerCleanup'

// Clean up stale service workers before React initialization
// This prevents cached JavaScript chunks from corrupting React's dispatcher
cleanupStaleServiceWorkers().then((isReloading) => {
  // Only mount React if we're not reloading
  if (!isReloading) {
    createRoot(document.getElementById("root")!).render(<App />);
  }
});
